module.exports = [{
      plugin: require('/Users/peter/Sites/Gatsby/peteromalley.co.uk/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/peter/Sites/Gatsby/peteromalley.co.uk/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-146133762-1","head":true},
    }]
